import { Cookies } from 'react-cookie';

import { Trap } from './types';

import axiosInterceptor from 'api/interceptor/axiosClient';

export const getTrap = async (slug: string, trapId: number) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`/object_traps_add_update/${slug}/${trapId}/`, {
    headers: {
      Authorization: token,
    },
  });
  return data.data as Trap;
};
